export const setTime = ({date, members, times}) => (dispatch) => {

    let hour = date.getHours();
    times.map((time) => {
        if (time.is_free && time.hour == hour) {
            let member_id = time.member_id;
            members.map((member) => {
                if (member.id == member_id) {
                    dispatch({type: 'SET_TIME', payload: {date: date, member: member}});
                }
            })
        }
    })


}

